import type { SVGProps } from 'react'

export const SuperhumanGoIcon: { __brand: 'color' | 'nocolor' } = (
  props: SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      color="#421D24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8045 10.1578C12.4472 9.55079 11.5559 9.55079 11.1986 10.1578L5.1544 20.4019C4.67495 21.2144 5.58 22.1341 6.40704 21.6794L11.5519 18.8599C11.8306 18.7087 12.1725 18.7087 12.4513 18.8599L17.5961 21.6794C18.4279 22.134 19.3282 21.2143 18.8539 20.4019L12.8045 10.1578ZM12.0016 2.2C10.3668 2.2 9.04006 3.52645 9.04006 5.15632C9.04041 6.79115 10.3671 8.11133 12.0016 8.11133C13.6409 8.1113 14.9666 6.79113 14.967 5.15632C14.967 3.52646 13.6411 2.20004 12.0016 2.2Z"
        fill="currentColor"
      />
    </svg>
  )
}

SuperhumanGoIcon.__brand = 'nocolor'
